import { gql } from "@apollo/client";

export const lensSourceListItemFragment = gql`
    fragment LensSourceListItem on LenssourceModelLensSource {
        id
        name
        lensSourceType
        externalId
    }
`;
